var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HEADER") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACy3fD9AAABW0lEQVQ4EWNUVfQvYWJktGOgAvjPwHCOiVqGgdzDyMBgxEQFh6EYwYLCI8ABeukxI8O/+exff1z/xsv8598/Hg4Whl/WjAyMGTCtRBsIMoyVk7Xw6tXVv8CaX4LJn+rKQR8Z/v+DmcdAtIEgl8ENA2rXlfMW/MbKwsPw748wAyMi5Ig28DcD+22YM9SU/QN//WdMZAE6m4ERGBVIAGE0kiA25r17qz/CxBn/M6jB2Og00Qaia8TFx+vl/wyMx/4w/FmGrvk/y7+5f/4wLAeJs/5nygF6WwOmBq+BDP//f7l3f/MjmGIYfevW5jcwtrpSIB8DAygwIYBCLzcwAY0SgxkGohnVlQI2IQugsX8BNXwHid26tyEWJqeqHJALjBiz/wz/gQmGEehCBMDvZQYGNmCiYEMoh7CY/v/nArqFH5hD0KUYKPQyhnmjBmIGCckioHR0jmRdODSAzAIAo5xXVrYP7bAAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HEADER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Facebook",
    href: "#img1",
    transform: "matrix(1,0,0,1,0,0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ade60f290346c3f586add3305632a340.svg";
export { ForwardRef as ReactComponent };